import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShoppingCart, X, ArrowRight } from 'lucide-react';
import { useCart } from '@/lib/cartContext';
import { formatINR } from '@/lib/savings';

export function MiniCartDrawer({ open, onClose, lastItem }) {
  const { itemCount } = useCart();

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/20 z-40" onClick={onClose} />
      <div className="fixed top-0 right-0 h-full w-full max-w-sm bg-white shadow-2xl z-50 flex flex-col animate-slide-in-right" data-testid="mini-cart-drawer">
        <div className="flex items-center justify-between p-5 border-b border-stone-100">
          <div className="flex items-center gap-2">
            <ShoppingCart className="w-5 h-5 text-[#0061DD]" />
            <h3 className="text-lg font-bold text-[#1A1A1A]">Quote Cart</h3>
            <span className="mono text-sm text-[#A8A29E]">({itemCount} items)</span>
          </div>
          <button onClick={onClose} className="text-[#A8A29E] hover:text-[#1A1A1A]" data-testid="close-mini-cart">
            <X className="w-5 h-5" />
          </button>
        </div>

        {lastItem && (
          <div className="p-5 bg-emerald-50/50 border-b border-emerald-100">
            <p className="text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-2">Added to cart</p>
            <div className="flex gap-3">
              <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center shrink-0">
                <img src={lastItem.image} alt={lastItem.product_name} className="max-w-full max-h-full object-contain" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-[#1A1A1A] truncate">{lastItem.product_name}</p>
                <p className="text-xs text-[#57534E] mono">{lastItem.pcs_kw} kW · {lastItem.battery_kwh} kWh</p>
                <span className={`inline-block mt-1 text-xs font-medium px-2 py-0.5 rounded-full ${lastItem.mode === 'buy' ? 'bg-stone-100 text-[#1A1A1A]' : 'bg-blue-50 text-[#0061DD]'}`}>
                  {lastItem.mode === 'buy' ? 'Buy' : 'Rent'}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="flex-1 p-5 flex flex-col gap-3">
          <Link to="/cart" onClick={onClose}>
            <Button className="w-full rounded-full bg-[#0061DD] hover:bg-[#004BB3] text-white py-5 text-sm font-semibold gap-2" data-testid="mini-cart-view-btn">
              View Quote Cart <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
          <Button variant="outline" onClick={onClose} className="w-full rounded-full border-stone-200 text-[#57534E] py-5 text-sm" data-testid="mini-cart-continue-btn">
            Continue Browsing
          </Button>
        </div>
      </div>
    </>
  );
}
